import portalApi from './portalApi';

const portalMessageService = {
  getConversations: () => portalApi.get('/portal/messages'),
  getMessages: (conversationId) => portalApi.get(`/portal/messages/${conversationId}`),
  sendMessage: (data) => portalApi.post('/portal/messages', data),
  getUnreadCount: () => portalApi.get('/portal/messages/unread-count'),
};

export default portalMessageService;
